import {
	renumberAllChaptersPages,
	renumberAllInitialChaptersPages
} from '@editor2/services/conflictResolutionService';
import { type CourseState } from '@editor2/types/courseState';
import { updateCourseChanges } from '../adapters/helpers';
import { getConflictDetector } from './conflictDetector';

export const applyPossiblyConflictingDiff = (state: CourseState, nodes: any[]) => {
	nodes.reverse().forEach((node) => {
		const conflictDetector = getConflictDetector(node);

		if (!conflictDetector) return;

		const data = conflictDetector.detectConflicts(state, node);

		const { conflicts, updatedInitial, updatedCurrent } = data;
		const commonPayload = { family_id: node?.family_id, state, nodes };

		conflictDetector.applyDiffToInitial({ ...commonPayload, updatedInitial });
		conflictDetector.applyDiffToCurrent({ ...commonPayload, updatedCurrent });
		conflictDetector.applyConflict({ state, conflicts });
	});

	// after all cleanup
	renumberAllChaptersPages(state);
	renumberAllInitialChaptersPages(state);
	updateCourseChanges(state);

	return state;
};
